<template>
    <div v-if="endpoint !== undefined && endpoint !== ''" class="quiz__campaign__endpoint" :class="{ 'quiz__campaign__endpoint-active' : is_active }">
        <div class="takeover" :class="{ 'takeover-active ': takeover_active }">
            <a class="takeover-close" @click.prevent="hideVideo">&times;</a>
            <div v-if="hasVideo" class="responsive-video">
                <div id="player"></div>
            </div>
        </div>
        <div class="quiz__campaign__endpoint-header-container" :class="{ 'quiz__campaign__endpoint-header-container-no-image' : !hasHeader }">
            <div class="quiz__campaign__endpoint-header">
                <div class="quiz__campaign__endpoint-header-title">
                    <h2 v-if="endpoint.show_answers == 1 && null !== dynamicTitle && dynamicTitle.length > 0"><em>{{ dynamicTitle }}</em></h2>
                    <h1>{{ endpoint.title }}</h1>
                    <!-- If video add Youtube link? -->
                    <a @click.prevent="showVideo" v-if="hasVideo" class="video-link" title="Play" href="#">Play</a>
                    <!-- End v-if -->

                </div>
                <div v-if="hasHeader" class="quiz__campaign__endpoint-header-image">
                    <img :src="endpoint.header_media.image_urls.large" :alt="endpoint.header_media.alt_text" />
                    <a @click.prevent="showVideo" v-if="hasVideo" class="mobile-video-link" title="Play" href="#"></a>
                </div>
            </div>
            <qc-primary-product v-if="hasProduct" :shopconfig="shopconfig" :with_link="endpoint.attached_product_content" :product_content="endpoint.product_content" :product="endpoint.attached_product"></qc-primary-product>
        </div>
        <div v-if="blocks.length > 0">
            <endpoint-blocks :blocks="blocks" :shopconfig="shopconfig" :endpoint="endpoint" :campaign="endpoint.campaign" :spotifyshare="spotifyshare"></endpoint-blocks>
        </div>
    </div>
</template>
<script>
import QcPrimaryProduct from './content-blocks/primary-product';
import EndpointBlocks from './endpoint-blocks';

export default {
    props: ['shopconfig','the_endpoint','show','producturl','blocks','spotifyshare'],
    components: {
        EndpointBlocks,
        QcPrimaryProduct
    },
    computed: {
        dynamicTitle: function(){
            let localStorage = window.localStorage;
            return localStorage.getItem('title').replace(',',', ');
        },
        hasProduct: function() {
            return this.endpoint.attached_product !== null && this.endpoint !== "";
        },
        hasHeader: function(){
            return this.endpoint.header_media !== null && this.endpoint !== "";
        },
        hasVideo: function(){
            if( this.endpoint !== "" && this.endpoint.header_media !== null ) return this.endpoint.header_media.youtube !== null && this.endpoint !== "";
            else return false;
        }
    },
    methods: {
        showVideo()
        {
            this.takeover_active = true;
            if( null !== this.endpoint.header_media && this.player == null )
            {
                this.onYouTubeIframeAPIReady();
            }
            else if( this.player != null ) {
                this.player.playVideo();
            }
        },
        hideVideo()
        {
            this.stopVideo();
            this.takeover_active = false;
        },
        onYouTubeIframeAPIReady() {
            let vm = this;
            this.player = new YT.Player('player', {
                height: '390',
                width: '640',
                videoId: vm.endpoint.header_media.youtube,
                playerVars: {rel: 0},
                events: {
                    'onReady': vm.onPlayerReady
                }
            });
        },
        onPlayerReady(event) {
           event.target.playVideo();
        },
        stopVideo() {
            let vm = this;
            this.player.pauseVideo();
        }
    },
    mounted() {
        this.endpoint = this.the_endpoint;
        let vm = this;
        Event.$on('endpoint_loaded', ($event) => {
            vm.is_active = true;
        });
        Event.$on('endpoint_changed',($event) => {
            scroll(0,0);
            vm.is_active = false;
            vm.endpoint = "";
            setTimeout(() => {
                vm.endpoint = $event.endpoint;
                vm.is_active = true;
            }, 5000)
        });
        this.is_active = ( this.show == 1 ) ? true : false;
    },
    data() {
        return {
            is_active: false,
            takeover_active: false,
            player: null,
            player_done: false,
            endpoint: {
                blocks: [],
                attached_product: null,
                header_media: {
                    youtube: null,
                    image_urls: {}
                }
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/quiz-campaign/components/endpoint-page.vue